import { t } from "i18next";
import * as yup from "yup";

export const paymentValidationSchema = () => {
  return yup.object().shape({
    nameOnCard: yup
      .string()
      .matches(/^[a-zA-Z ]+$/, t("form.error.nameOnCard.invalidName")!)
      .min(3, t("form.error.nameOnCard.invalidName")!)
      .max(40, t("form.error.nameOnCard.invalidName")!)
      .required(t("form.error.nameOnCard.required")!),
    cardNumber: yup
      .string()
      .min(16, t("form.error.cardNumber.invalidCardNumber")!)
      .max(16, t("form.error.cardNumber.invalidCardNumber")!)
      .required(t("form.error.cardNumber.required")!),
    CVV: yup
      .string()
      .min(3, t("form.error.CVV.invalidCVV")!)
      .max(3, t("form.error.CVV.invalidCVV")!)
      .required(t("form.error.CVV.required")!),
    expirationDate: yup
      .string()
      .matches(
        /([0-9]{2})\/([0-9]{2})/,
        t("form.error.expirationDate.invalidExpirationDate")!
      )
      .required(t("form.error.expirationDate.required")!),
  });
};
